// extracted by mini-css-extract-plugin
export default {"popupWrapper":"fileUploaderError_popupWrapper__Yf5zQ","popupBody":"fileUploaderError_popupBody__2TDS+","buttonsWrapper":"fileUploaderError_buttonsWrapper__3wX6E"};